(function () {
  var odeimThemeConfig = function ($mdThemingProvider) {
    $mdThemingProvider.definePalette('odeim-primary', {
      '50': 'e8f1f9',
      '100': 'c6dcef',
      '200': 'a1c5e5',
      '300': '7baeda',
      '400': '5e9cd2',
      '500': '428bca',
      '600': '3c83c5',
      '700': '3378bd',
      '800': '2b6eb7',
      '900': '1d5bab',
      'A100': 'e3eeff',
      'A200': 'b0d0ff',
      'A400': '7db2ff',
      'A700': '63a3ff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('odeim-accent', {
      '50': 'e1e7ec',
      '100': 'b5c3d0',
      '200': '839bb1',
      '300': '517392',
      '400': '2c557a',
      '500': '073763',
      '600': '06315b',
      '700': '052a51',
      '800': '042347',
      '900': '021635',
      'A100': '6d97ff',
      'A200': '3a73ff',
      'A400': '074fff',
      'A700': '0044ec',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        'A100'
      ],
      'contrastLightColors': [
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A200',
        'A400',
        'A700'
      ]
    });

    $mdThemingProvider.definePalette('odeim-warn', {
      '50': 'fef1e4',
      '100': 'fcdcbc',
      '200': 'fbc58f',
      '300': 'f9ae62',
      '400': 'f79c41',
      '500': 'f68b1f',
      '600': 'f5831b',
      '700': 'f37817',
      '800': 'f26e12',
      '900': 'ef5b0a',
      'A100': 'ffffff',
      'A200': 'ffede5',
      'A400': 'ffcab3',
      'A700': 'ffb899',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '900'
      ]
    });

    $mdThemingProvider.theme('odeim')
      .primaryPalette('odeim-primary')
      .accentPalette('odeim-accent')
      .warnPalette('odeim-warn');
  };

  odeimThemeConfig.$inject = ['$mdThemingProvider'];
  angular.module('ecap').config(odeimThemeConfig);

  var odeimThemeRun = function ($rootScope) {
    if (!$rootScope.$themes) {
      $rootScope.$themes = {};
    }
    $rootScope.$themes['ecapwest'] = {
      primaryColor: '#233967',
      accentColor: '#1d84f5'
    };
  };

  odeimThemeRun.$inject = ['$rootScope'];
  angular.module('ecap').run(odeimThemeRun);
})();
